<template>
	<div class="cwrapper">
		<span v-if="!isMonth" :class="{'noshow': selectedDates == null }">
			{{ startDate }} a {{ endDate }}
		</span>
		<span v-else :class="{'noshow': selectedDates == null }">
			{{ monthDate }}
		</span>
		<img src="@/assets/images/calendar2.png"
			class="navigationItem" />
			
 	</div>
</template>

<script>
const formatter = 
  new Intl.DateTimeFormat("pt-PT", {
    day: "2-digit",
    month: "2-digit"
  });

const formatermont = 
  new Intl.DateTimeFormat("pt-PT",{
      day: "2-digit",
      month: "2-digit",
      year: 'numeric'
  });



export default {
 name: 'dateInput',
 props:["selectedDates","isMonth","lang"],
 data() {
	 return {
		 showCalendar: false,
		 start: null,
		 end: null
	 }
 },
 computed:{
	monthDate(){
		const dateMonthFormatter = 
			new Intl.DateTimeFormat(this.lang,{
				month: "long",
				year: 'numeric'
			});
		if(this.selectedDates == null){
			return ""
		}
		return dateMonthFormatter.format(this.selectedDates.start);
	},
	startDate(){
		if(this.selectedDates == null){
			return ""
		}
		return formatter.format(this.selectedDates.start);
	},
	endDate(){
		if(this.selectedDates == null){
			return ""
		}
		return formatermont.format(this.selectedDates.end);
	}
 },
 methods: {
	 clickedOutside(){
		 this.showCalendar = false;
	 }
 }
}
</script>

<style scoped>
.noshow{
 opacity: 0;
}

.cwrapper{
 border: 1px solid black;
 border-radius: 5px;
 white-space: nowrap;
 padding-right: 10px;
 padding-top: 10px;
 padding-bottom: 10px;
 padding-left: 25px;
 display: flex;
 justify-content: space-between;
 position:relative;
}

.header-color {
 color: #ccc;
}

img{
 width: 25px;
 height: 25px;
}

.cwrapper span {
	font-size: 14px;
	font-family: Montserrat Light,serif;
	color: #6a6868;
}
</style>